import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

const animateItems = (item: HTMLElement) => {
    const items = document.querySelectorAll<HTMLElement>('.animate--from-top')

    if (!items) {
        return
    }

    gsap.set(items, {
        y: -80,
        rotate: -8,
        scale: .5,
        autoAlpha: 0
    });

    gsap.to(items, {
        y: 0,
        rotate: 0,
        scale: 1,
        autoAlpha: 1,
        stagger: 0.1,
        delay: .3,
        ease: "power3.out",
        scrollTrigger: {
            trigger: item,
            start: 'top 80%',
            toggleActions: "play pause resume pause",
        }
    });
};

export default () => {
    const container = gsap.utils.toArray('.has-animated-items');

    if (!container) {
        return
    }

    document.addEventListener('facetwp-loaded', () => {
        ScrollTrigger.refresh()

        container.forEach((item: HTMLElement) => {
            animateItems(item)
        })
    })

    container.forEach((item: HTMLElement) => {
        animateItems(item)
    })
};